import FLAGS_MAP from "@public/flags/flagsMap.json";
import { DSFlagName } from "@/src/design_system/primitives/flag/types/flagName";

export const FLAGS = FLAGS_MAP.flags as DSFlagName[];
